import { ReduxState } from 'src/store/types';

export const permissionsSelector = (state: ReduxState) =>
  state.connections.permissions;

export const permissionsUnavailableSelector = (state: ReduxState) =>
  state.connections.permissionsUnavailable;

export const permissionsUsernameSelector = (state: ReduxState) =>
  state.connections.authenticatedUsername ??
  state.connections.connection?.username ??
  '';
